export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  REGISTER_USER: '/auth/registerUser',
  CHECK_USER: '/auth/checkuser',

  // User
  PROFILE: '/user/profile',
  UPDATE_PROFILE: '/user/update-profile',
  UPDATE_NAME: '/user/update-name',
  UPDATE_USER_TIMEZONE: '/user/update-timezone',
  SETTINGS: '/user/settings',

  // Phone Verification
  GENERATE_OTP: '/user/generate-otp',
  VERIFY_OTP: '/user/verify-otp',
  UNVERIFY_PHONE: '/user/unverify-phone-number',

  // Billing
  GENERATE_CUSTOMER_SECRET: '/user/generate-customer-secret',

  // Tasks
  TASKS: '/api/tasks',
  TASK: (id: string) => `/api/tasks/${id}`,

  // Chat
  CHAT_HISTORY: '/user/chat/history',
  CHAT_SAVE: '/user/chat/save',
  CHAT_CLEAR: '/user/chat/clear',

  // Calendar Management (Unified)
  DELETE_SPECIFIC_CALENDAR: (domain: string, calendarId: string) =>
    `/user/calendar/${domain}/${calendarId}`,

  // Google Calendar
  GOOGLE_AUTH_URL: '/user/getGoogleCalendarAuthUrl',
  CONNECT_GOOGLE_CALENDAR: '/user/addCalendar',

  // Outlook Calendar
  OUTLOOK_AUTH_URL: '/integrations/outlook/auth-url',
  CONNECT_OUTLOOK_CALENDAR: '/integrations/outlook/connect',

  // Task Calendar Sync
  SYNC_CALENDAR_EVENTS: '/task/syncAllCalendarEvents',

  // Public Profile
  PUBLIC_PROFILE: (username: string) => `/public-profile/${username}`,
  PUBLIC_PROFILE_BY_USER_ID: (userId: string) =>
    `/public-profile/user/${userId}`,

  // Profile Links & QR Codes
  PROFILE_LINK: (canonicalId: string) => `/public-profile/links/${canonicalId}`,
  PROFILE_QR_SVG: (canonicalId: string) =>
    `/public-profile/qr/${canonicalId}.svg`,

  // Booking
  CREATE_BOOKING: '/booking/create',
  OPTIMAL_TIME_SLOTS: '/booking/optimal-slots',

  // Meeting Requests (Public event link)
  MEETING_REQUEST: (eventSlug: string, attendeeId: string) =>
    `/event/${eventSlug}/${attendeeId}`,
} as const;
